export default "__VITE_ASSET__gQz89y3F__"